import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BadgeCheck } from "lucide-react";
import { Reveal, RevealGroup, RevealItem } from "@/components/common/Reveal";
import SectionLabel from "@/components/common/SectionLabel";

const BENEFITS = [
  "Mantenimiento preventivo y correctivo",
  "Soluciones para el sector industrial",
  "Diagnóstico y reparación especializada",
  "Soluciones para el sector naval",
  "Suministro de repuestos certificados",
  "Atención técnica especializada",
  "Soluciones para el sector automotriz",
  "Respaldo profesional en cada proyecto",
];

export default function AboutSection() {
  return (
    <section data-testid="about-section" className="bg-gema-black py-24 md:py-32 border-t border-white/5">
      <div className="container-gema grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20 items-center">
        {/* Content */}
        <div className="lg:col-span-7">
          <Reveal>
            <SectionLabel index="01">Sobre GEMA</SectionLabel>
          </Reveal>

          <Reveal delay={0.1}>
            <h2 className="heading-lg text-white mt-7 max-w-xl">
              Soluciones técnicas para los sectores{" "}
              <span className="text-gema-red">automotriz, industrial y naval</span>
            </h2>
          </Reveal>

          <Reveal delay={0.2}>
            <p className="mt-7 text-white/60 leading-relaxed max-w-xl">
              En GEMA ofrecemos soluciones integrales en mantenimiento, reparación y suministro técnico
              para los sectores automotriz, industrial y naval. Combinamos experiencia técnica, personal
              calificado y procesos orientados a la calidad para brindar un servicio confiable, eficiente
              y adaptado a las necesidades de cada cliente.
            </p>
          </Reveal>

          <RevealGroup className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4 mt-10 max-w-xl" stagger={0.06}>
            {BENEFITS.map((b) => (
              <RevealItem key={b} y={16}>
                <div className="flex items-start gap-3">
                  <BadgeCheck className="h-5 w-5 text-gema-red mt-0.5 shrink-0" strokeWidth={1.75} />
                  <span className="text-white/80 text-sm leading-snug">{b}</span>
                </div>
              </RevealItem>
            ))}
          </RevealGroup>

          <Reveal delay={0.3}>
            <Link to="/nosotros" data-testid="about-cta" className="btn-primary mt-12 group">
              Nuestra Empresa
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>

        {/* Image */}
        <div className="lg:col-span-5">
          <Reveal delay={0.2} className="relative">
            <div className="relative overflow-hidden">
              <img
                src="https://images.pexels.com/photos/15543138/pexels-photo-15543138.jpeg"
                alt="Técnico realizando mantenimiento y diagnóstico de un motor automotriz"
                className="w-full h-[420px] md:h-[560px] object-cover transition-transform duration-700 hover:scale-[1.03]"
                loading="lazy"
              />
              <div className="absolute inset-0 border border-white/10 pointer-events-none" />
              <span className="absolute top-4 left-4 h-px w-10 bg-gema-red" aria-hidden="true" />
              <span className="absolute top-4 left-4 w-px h-10 bg-gema-red" aria-hidden="true" />
            </div>
            <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
              Ingeniería · Precisión · Confiabilidad
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
